import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { RootState } from '@kopapro-redux/store';
import NewsletterPage from '@kopapro/components/pages/newsletter/newsletter';
import { withTranslation, WithTranslation } from 'react-i18next';

import { NewsletterContent } from '@kopapro-redux/types/componentSetting';
import { getDataByComponent } from '@kopapro-redux/selectors/entities/shop';
import { subscribeNewsletter } from '@kopapro-redux/actions/user';
import { M18RnMeta } from '@kopapro/utils/constants/m18';

interface IProps extends WithTranslation {}

interface DispatchProps {
  subscribe: typeof subscribeNewsletter;
}

interface StateProps {
  compId: string;
  compName: string;
  content: NewsletterContent | undefined;
}

const mapStateToProps: MapStateToProps<StateProps, IProps, RootState> = (state: RootState, props: IProps) => {
  const compName = M18RnMeta.NEWSLETTERPAGE;
  const compId = M18RnMeta.NEWSLETTERPAGE;
  const data = getDataByComponent(state, { compId, compName })?.content;
  return {
    compId,
    compName,
    content: data,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, IProps> = {
  subscribe: subscribeNewsletter,
};

export type NewsletterPageProps = IProps & StateProps & DispatchProps;
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(NewsletterPage));
